import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import * as queryString from "query-string";
import { IApplicationState, AuthActionCreators, AppActionCreators, IAuthState } from "@nkr/store/index";

interface IOwnProps extends RouteComponentProps<{}> { }

interface IStateProps {
    auth: IAuthState
}

interface IDispatchProps {
    clearAuth: () => void,
    clearPortalOpo: () => void
}

type TLogout =
    IOwnProps
    & IStateProps
    & IDispatchProps;

class Logout extends React.Component<TLogout, {}> {
    componentDidMount = () => {
        let parsed = queryString.parse(this.props.location.search);

        let url = parsed.next != null ? "/login?next=" + parsed.next : "/login";

        this.props.clearAuth();
        this.props.clearPortalOpo();

        this.props.history.push(url);
    }

    render = () => {
        return null;
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        auth: state.auth
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        clearAuth: (): void => { dispatch(AuthActionCreators.clearAuth()); },
        clearPortalOpo: (): void => { dispatch(AppActionCreators.setPortalOpo(null)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(Logout);
